<template>
  <div
    class="tw:w-full tw:bg-yellow-500 tw:px-4 tw:py-2 tw:flex tw:items-center tw:justify-center tw:gap-4 max-no-active-popups-bar-height"
  >
    <span class="tw:text-black tw:body-1 tw:line-clamp-2">
      {{ trans._notifications.noActivePopups }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { POOR_ONSITE_BAR_HEIGHT } from "vue-app/types/enums";

const noActivePopupsBarHeightCss = `${POOR_ONSITE_BAR_HEIGHT}rem`;
</script>

<style scoped>
.max-no-active-popups-bar-height {
  max-height: v-bind(noActivePopupsBarHeightCss);
}
</style>
